<template>
  <section>
     <Form :label-width="250">
       <FormItem  label="取价房间ID：">
          <p>{{data.unifyPriceRoomId}}</p>
        </FormItem>
       <FormItem  label="取价房间名称：">
          <p>{{data.unifyPriceRoom}}</p>
        </FormItem>
       <FormItem  label="打包房数：">
          <p>{{data.packageCount}}</p>
        </FormItem>
       <FormItem  label="有效房数：">
         <p>{{data.validCount}}</p>
       </FormItem>
       <FormItem  label="本日可用房量：">
         <p>{{data.availableCount}}</p>
       </FormItem>
       <FormItem  label="缓存房量：">
         <p>{{data.bufferCount}}</p>
       </FormItem>
       <FormItem  label="本日渠道剩余可用房量：">
          <p>{{data.remainCount}}</p>
        </FormItem>
        <Button type="primary" @click="openEditInfoModal">编辑缓冲房量</Button>
     </Form>

     <Modal v-model="editInfoModal.display" ref="editInfoModal" :loading="true" :width="1000" title="修改缓冲房量信息" @on-ok="preEditInfo" ok-text="提交内容" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" ref="editInfoModalForm" :model="editInfoModal" :rules="rules" :label-width="150">
        <FormItem label="房型名称：" prop="name">
          <Input type="text" v-model="editInfoModal.bufferNum" placeholder="查询关键字"></Input>
        </FormItem>
      </Form>
    </Modal>
  </section>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          name: ''
        };
      }
    }
  },
  data() {
    return {
      editInfoModal: {
        display: false,
        name: '',
      },
      rules: {
        channelHotelName: [
          { required: true, message: "房型名称不能为空", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    openEditInfoModal() {
      this.initEditInfoModal();

      this.editInfoModal.display = true;
    },
    initEditInfoModal() {
      this.editInfoModal = Object.assign({}, this.editInfoModal, {
        name: this.data.name
      });
    },
    preEditInfo() {
      let validResult = true;
      this.$refs.editInfoModalForm.validate(valid => {
        validResult = valid;
      });
      if (!validResult) {
        this.$refs.editInfoModal.buttonLoading = false;
        return;
      }
    },
    updateStatus() {
      if (this.data.status === "S01") {
        this.confirmUpdateStatus();
        return;
      }
    },
    confirmUpdateStatus() {
      this.$Modal.confirm({
        title: "提示",
        content: "确定将此门店从渠道下线？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          console.info("下线渠道");
        }
      });
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ota/tujia/roomtype-detail/packaging-info.vue